/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { MenuComponent } from '../../../assets/ts/components';
import { KTSVG } from '../../../helpers';
import { useLayout } from '../../core';
import { Header } from './Header';
import { Topbar } from './Topbar';
import { ThemeToggle } from '../../../../app/components/ThemeToggle';
import { useObtenerEventosSelect } from '../../../../app/pages/eventos/hooks/EventosHook';
import { RootState } from '../../../../setup';

export function HeaderWrapper() {
  const { pathname } = useLocation();
  const { config, classes, attributes } = useLayout();
  const { list } = useObtenerEventosSelect(0);
  const { header, aside } = config;

  // Lee el token directamente del Redux store (siempre sincrónico)
  const accessToken = useSelector((state: RootState) => state.auth.accessToken);

  // Decodifica evento_id del JWT
  const eventoIdSesion = useMemo<number | null>(() => {
    if (!accessToken) return null;
    try {
      const payload = JSON.parse(atob(accessToken.split('.')[1]));
      return payload.evento_id ?? null;
    } catch {
      return null;
    }
  }, [accessToken]);

  const eventoActual = list.find((evento) => evento.id === eventoIdSesion);
  const nombreEvento = eventoActual?.data?.nombre ?? 'Ticket Cash';

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [pathname]);

  return (
    <>
      <Helmet>
        <title>{nombreEvento}</title>
      </Helmet>
      <div
        id="kt_header"
        className={clsx(
          'header',
          classes.header.join(' '),
          'align-items-stretch'
        )}
        {...attributes.headerMenu}
      >
        <div
          className={clsx(
            classes.headerContainer.join(' '),
            'd-flex align-items-stretch justify-content-between'
          )}
        >
          {/* begin::Aside mobile toggle */}
          {aside.display && (
            <div
              className="d-flex align-items-center d-lg-none ms-n3 me-1"
              title="Show aside menu"
            >
              <div
                className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                id="kt_aside_mobile_toggle"
              >
                <KTSVG
                  path="/media/icons/duotune/abstract/abs015.svg"
                  className="svg-icon-2x mt-1"
                />
              </div>
            </div>
          )}
          {/* end::Aside mobile toggle */}

          <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
            <div className="d-flex align-items-center d-none d-lg-flex" id="kt_header_nav">
              <h1 className="text-white fw-bolder my-1 fs-3">{nombreEvento}</h1>
            </div>

            <div className="d-flex align-items-center ms-auto" id="kt_header_nav">
              <span className="text-white fw-bold fs-6 me-2">Evento:</span>
              <span className="badge badge-light-primary fs-7 fw-bolder px-3 py-2">
                {eventoActual ? eventoActual.data?.nombre : '—'}
              </span>
            </div>

            {header.left === 'menu' && (
              <div className="d-flex align-items-stretch" id="kt_header_nav">
                <Header />
              </div>
            )}

            <div className="d-flex align-items-stretch flex-shrink-0 align-items-center">
              <ThemeToggle />
              <Topbar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
